import {DELETE_ONE_REQUEST} from "../../../enums/Request/request.types";

export const deleteCurrentRequestAction = (uid) =>{
    return {
        type: DELETE_ONE_REQUEST,
        payload: uid,
    };
};
